const Shoping = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_125_2563)">
        <path
          d="M38.8281 9.53125H32.8451L32.8125 7.02336C32.8083 3.14992 29.6557 0 25.7812 0C21.9042 0 18.75 3.15422 18.75 7.03125C18.75 7.03633 18.75 7.04141 18.7501 7.04648L18.7823 9.53125H12.8125C12.1653 9.53125 11.6406 10.0559 11.6406 10.7031V18.9062H1.17188C0.524687 18.9062 0 19.4309 0 20.0781V36.4844C0 38.4229 1.57711 40 3.51562 40H22.4219H24.7656H36.4844C38.4229 40 40 38.4229 40 36.4844V10.7031C40 10.0559 39.4753 9.53125 38.8281 9.53125ZM25.7812 2.34375C28.3659 2.34375 30.4688 4.44656 30.4688 7.03125C30.4688 7.03633 30.4688 7.04141 30.4688 7.04648L30.5012 9.53125H21.1263L21.0938 7.02414C21.0976 4.44266 23.1989 2.34375 25.7812 2.34375ZM25.9375 36.4844C25.9375 37.1305 25.4118 37.6562 24.7656 37.6562H22.4219H3.51562C2.86945 37.6562 2.34375 37.1305 2.34375 36.4844V21.25H25.9375V36.4844ZM37.6562 36.4844C37.6562 37.1305 37.1305 37.6562 36.4844 37.6562H28.0797C28.2098 37.2895 28.2812 36.8952 28.2812 36.4844V20.0781C28.2812 19.4309 27.7566 18.9062 27.1094 18.9062H13.9844V11.875H18.8128L18.8282 13.0621C18.8365 13.7041 19.3595 14.2188 19.9997 14.2188C20.0048 14.2188 20.01 14.2187 20.0152 14.2187C20.6624 14.2102 21.1802 13.6788 21.1718 13.0316L21.1567 11.875H30.5316L30.547 13.0621C30.5552 13.7041 31.0783 14.2188 31.7184 14.2188C31.7236 14.2188 31.7288 14.2187 31.734 14.2187C32.3812 14.2102 32.899 13.6788 32.8905 13.0316L32.8755 11.875H37.6562V36.4844Z"
          fill="currentColor"
        />
        <path
          d="M20 23.5938C19.3528 23.5938 18.8281 24.1184 18.8281 24.7656V25.9375C18.8281 28.5222 16.7253 30.625 14.1406 30.625C11.5559 30.625 9.45312 28.5222 9.45312 25.9375V24.7656C9.45312 24.1184 8.92844 23.5938 8.28125 23.5938C7.63406 23.5938 7.10938 24.1184 7.10938 24.7656V25.9375C7.10938 29.8145 10.2636 32.9688 14.1406 32.9688C18.0177 32.9688 21.1719 29.8145 21.1719 25.9375V24.7656C21.1719 24.1184 20.6472 23.5938 20 23.5938Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_125_2563">
          <rect width="40" height="40" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Shoping;
